import { RouteRecordRaw } from "vue-router"
import { MediaRouteNameEnum } from "@/shared/enums/routes/media.enum.ts"
import { AppPermissions } from "@/shared/permissions"

export const mediaRoutes: RouteRecordRaw[] = [
	{
		path: "/media",
		name: MediaRouteNameEnum.list,
		component: () => import("@/pages/media/MediaListPage.vue"),
		meta: {
			title: MediaRouteNameEnum.list,
			layout: "MainLayout",
			authRequired: true,
			permission: { any: [AppPermissions.CanViewOwnFiles, AppPermissions.CanViewSubordinateFiles] },
		},
	},
	{
		path: "/media/:company_id?/:id",
		name: MediaRouteNameEnum.detail,
		component: () => import("@/pages/media/MediaDetailPage.vue"),
		meta: {
			title: MediaRouteNameEnum.detail,
			layout: "MainLayout",
			authRequired: true,
			permission: { any: [AppPermissions.CanViewOwnFiles, AppPermissions.CanViewSubordinateFiles] },
		},
	},
	{
		path: "/media/upload",
		name: MediaRouteNameEnum.upload,
		component: () => import("@/pages/media/MediaUploadPage.vue"),
		meta: {
			title: MediaRouteNameEnum.upload,
			layout: "MainLayout",
			authRequired: true,
			permission: AppPermissions.CanUploadCampaignFile,
		},
	},
];
